<header aria-label="Site header" class="header">
  <nav class="header-container wrapper">

    <a href="https://www.eastsussex.gov.uk/" class="logo">
      <img src="assets/images/escc-logo.webp" alt="East Sussex Site Logo">
    </a>

  </nav>

</header>